import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NotificationCenterComponent } from './notification-center/notification-center.component';
import { NotificationComponent } from './notification/notification.component';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../core.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    TranslateModule
  ],
  declarations: [
    NotificationComponent,
    NotificationCenterComponent
  ],
  providers: [
  ],
  exports: [
    NotificationCenterComponent
  ]
})
export class NotificationsModule { }